const schemaFilter = {
    founded_in:undefined,
    jasica:undefined,
}

export default schemaFilter;